import { createFileRoute } from "@tanstack/react-router";
import ProgramaAfiliados from "../pages/ProgramaAfiliados";

export const Route = createFileRoute("/programa-afiliados")({
  component: ProgramaAfiliados,
});
